import { alpha, type SxProps, type Theme } from '@mui/material/styles';

export type CountTaskStatus = 'Created' | 'InProgress' | 'Completed' | 'Approved' | 'Cancelled';

/** Yönetici panelinden iptal edilebilir statüler */
export const CANCELLABLE_COUNT_STATUSES: CountTaskStatus[] = ['Created', 'InProgress'];

export function canCancelCountTask(status: string): boolean {
  return CANCELLABLE_COUNT_STATUSES.includes(status as CountTaskStatus);
}

export function isCountTaskCancelled(status: string): boolean {
  return status === 'Cancelled';
}

export function isCountTaskActive(status: string): boolean {
  return status === 'Created' || status === 'InProgress';
}

/** İptal edilmiş satırlar için tablo satır stili — aktif işlere odaklanmayı kolaylaştırır */
export function getCancelledCountTaskRowSx(status: string): SxProps<Theme> | undefined {
  if (status !== 'Cancelled') return undefined;
  return {
    opacity: 0.55,
    bgcolor: (theme) => alpha(theme.palette.text.disabled, 0.06),
    '& .MuiTableCell-root': { color: 'text.secondary' },
    '& .MuiChip-root': { opacity: 0.85 },
  };
}
